import { render } from "./cu-dialog.vue?vue&type=template&id=8f90bbe2"
import script from "./cu-dialog.vue?vue&type=script&lang=js"
export * from "./cu-dialog.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kexikui/Desktop/code/dlmk/delemick-pc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__